export default "__VITE_ASSET__CyhVdzP7__"